<section class="page-wrapper scroll-container">
  <div class="d-flex">
    <h1 class="mb-0 me-auto">{{ salutation }}</h1>
    <span *hasMinRole="'CSR1'">
      <lib-search></lib-search>
    </span>
  </div>
  <h6 class="mb-0">{{ dayStamp }}</h6>
  <div class="row">
    <div class="col-12" [ngClass]="{ 'expanded-col': cardExpanders['taskList'] }">
      <div class="card card-shadow mb-lg-3" *hasMinRole="'CSR1'; else nonCSRTasks">
        <div class="card-body py-2 px-4">
          <div class="d-flex">
            <ul
              ngbNav
              #taskNav="ngbNav"
              class="nav-tabs me-auto"
              (navChange)="onTaskTabChange($event)">
              <li ngbNavItem [ngbNavItem]="'payroll-tasks'">
                <a ngbNavLink class="tab-title">
                  Payroll Schedule&nbsp;
                  <span class="task-count-bubble">
                    {{ taskCount['payroll']['open'] + taskCount['payroll']['remaining'] }}
                  </span>
                </a>
                <ng-template ngbNavContent>
                  <payroll-task-list
                    [csrOfficeMap]="csrOfficeMap"
                    [expandedTasks]="expandedTasks"
                    [tasks]="payrollTasks"
                    [taskTypes]="taskTypes"
                    [searchConfig]="payrollTaskSearchConfig"
                    [viewMembers]="viewMembers"
                    (onEditTask)="editTask(taskModal, $event)"
                    (onGetTasks)="getPayrollTasks($event)"
                    (onSetTaskContainer)="setTaskContainer($event)"
                    (onTaskSelect)="updateSelectedTasks($event)"
                    (onToggleExpTasks)="toggleExpandedTasks($event)"
                    (onToggleSubTaskComplete)="toggleSubTaskCompletion($event)"
                    [clearSelTaskEvent]="clearSelTasksSubject.asObservable()">
                  </payroll-task-list>
                </ng-template>
              </li>
              <li ngbNavItem [ngbNavItem]="'other-tasks'">
                <a ngbNavLink class="tab-title">
                  Other Tasks&nbsp;
                  <span class="task-count-bubble">
                    {{ taskCount['other']['open'] + taskCount['other']['remaining'] }}
                  </span>
                </a>
                <ng-template ngbNavContent>
                  <other-task-list
                    [csrOfficeMap]="csrOfficeMap"
                    [expandedTasks]="expandedTasks"
                    [tasks]="otherTasks"
                    [taskTypes]="taskTypes"
                    [searchConfig]="otherTaskSearchConfig"
                    [viewMembers]="viewMembers"
                    (onEditTask)="editTask(taskModal, $event)"
                    (onGetTasks)="getOtherTasks($event)"
                    (onSetTaskContainer)="setTaskContainer($event)"
                    (onTaskSelect)="updateSelectedTasks($event)"
                    (onToggleExpTasks)="toggleExpandedTasks($event)"
                    (onToggleSubTaskComplete)="toggleSubTaskCompletion($event)"
                    [clearSelTaskEvent]="clearSelTasksSubject.asObservable()">
                  </other-task-list>
                </ng-template>
              </li>
            </ul>
            <div class="d-flex pt-2 pe-2">
              <label class="mt-1">View:&nbsp;&nbsp;</label>
              <div class="d-inline-block" ngbDropdown container="body" #taskViewDd="ngbDropdown">
                <button
                  cpGTagEvent
                  [params]="{ event_label: 'csr_home_task_view_dropdown' }"
                  class="btn btn-primary btn-xs"
                  id="dropdownManual"
                  ngbDropdownAnchor
                  (focus)="taskViewDd.open()">
                  {{ taskViewMode[taskView] | camelToTitle }}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownManual">
                  <button
                    cpGTagEvent
                    [params]="{ event_label: 'csr_home_task_view_my_tasks' }"
                    ngbDropdownItem
                    [ngClass]="{ active: taskView == taskViewMode.MyTasks }"
                    (click)="changeTaskView(taskViewMode.MyTasks)">
                    <small>My Tasks</small>
                  </button>
                  <fieldset *hasMinRole="'CSR1'">
                    <div class="dropdown-divider"></div>
                    <button
                      cpGTagEvent
                      [params]="{ event_label: 'csr_home_task_view_my_office_tasks' }"
                      ngbDropdownItem
                      [ngClass]="{ active: taskView == taskViewMode.MyOfficeTasks }"
                      (click)="changeTaskView(taskViewMode.MyOfficeTasks)">
                      <small>My Office Tasks</small>
                    </button>
                    <div class="dropdown-divider"></div>
                    <button
                      cpGTagEvent
                      [params]="{ event_label: 'csr_home_task_view_csr_tasks' }"
                      class="btn-task-dropdown"
                      (click)="changeTaskView(taskViewMode.CSRTasks)"
                      [ngClass]="{ active: taskView == taskViewMode.CSRTasks }">
                      <small>View Tasks by CSR</small>&nbsp;
                      <i
                        class="fas pt-1"
                        [ngClass]="
                          taskView == taskViewMode.CSRTasks ? 'fa-caret-down' : 'fa-caret-right'
                        ">
                      </i>
                    </button>
                    <div class="px-4" [hidden]="taskView != taskViewMode.CSRTasks">
                      <input
                        class="form-control mt-1 mb-3"
                        placeholder="Search CSR..."
                        [(ngModel)]="csrSearchText"
                        value=""
                        (ngModelChange)="searchCSRs(csrSearchText)"
                        style="height: 38px" />
                      <ul class="csr-search-results">
                        <li *ngFor="let csr of csrSearchResults">
                          <a
                            (click)="
                              changeTaskView(taskViewMode.CSRTasks, null, csr); taskViewDd.close()
                            "
                            class="cp-green">
                            {{ csr.firstName }} {{ csr.lastName }}
                          </a>
                        </li>
                      </ul>
                      <em *ngIf="csrSearchText && (!csrSearchResults || !csrSearchResults.length)">
                        <small>No CSRs found</small>
                      </em>
                    </div>
                    <div class="dropdown-divider"></div>
                    <button
                      cpGTagEvent
                      [params]="{ event_label: 'csr_home_task_view_office_tasks' }"
                      class="btn-task-dropdown"
                      (click)="changeTaskView(taskViewMode.OfficeTasks)"
                      [ngClass]="{ active: taskView == taskViewMode.OfficeTasks }">
                      <small>View Tasks by Office</small>&nbsp;
                      <i
                        class="fas pt-1"
                        [ngClass]="
                          taskView == taskViewMode.OfficeTasks ? 'fa-caret-down' : 'fa-caret-right'
                        ">
                      </i>
                    </button>
                    <div class="px-4" [hidden]="taskView != taskViewMode.OfficeTasks">
                      <select
                        class="form-control mt-1"
                        [(ngModel)]="selOffice"
                        (ngModelChange)="
                          changeTaskView(taskViewMode.OfficeTasks, selOffice); taskViewDd.close()
                        "
                        style="height: 38px">
                        <option
                          ngbDropdownItem
                          *ngFor="let office of csrOfficeMap"
                          [ngValue]="office">
                          {{ office.Name }}
                        </option>
                      </select>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
            <div class="pt-2">
              <button
                cpGTagEvent
                [params]="{ event_label: 'csr_home_add_task' }"
                (click)="addTask(taskModal)"
                class="btn btn-xs btn-primary me-2">
                <i class="fas fa-xs fa-plus"></i>&nbsp;Task
              </button>
            </div>
            <div class="pt-2">
              <button
                cpGTagEvent
                [params]="{ event_label: 'csr_home_batch_edit_tasks' }"
                (click)="batchEditTasks(batchTaskModal)"
                class="btn btn-xs btn-secondary"
                *hasMinRole="'CSR1'"
                [attr.disabled]="showBatchEditBtn() ? null : 'disabled'">
                Edit Selected Tasks
              </button>
            </div>
          </div>
          <div [ngbNavOutlet]="taskNav"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-lg-flex d-md-block justify-content-between home-page-cards">
    <div class="card card-shadow me-lg-2 mb-lg-2" style="flex: 1.5">
      <div class="card-body">
        <h3 class="card-title">Today's {{ currentTaskList }} tasks for View: {{ taskViewName }}</h3>
        <div *ngIf="currentTaskList == 'Payroll'" class="d-flex align-items-center">
          <div
            echarts
            [options]="options"
            class="donut-chart"
            (chartInit)="onChartInit($event)"></div>
          <div>
            <div class="text-center mb-2">
              <h3 class="mb-0">
                {{ taskCount['payroll']['open'] }}
              </h3>
              Open
            </div>
            <div class="text-center">
              <h3 class="mb-0">
                {{ taskCount['payroll']['remaining'] }}
              </h3>
              In Progress
            </div>
          </div>
        </div>
        <div *ngIf="currentTaskList == 'Other'" class="d-flex align-items-center">
          <div
            echarts
            [options]="options"
            class="donut-chart"
            (chartInit)="onChartInit($event)"></div>
          <div>
            <div class="text-center mb-2">
              <h3 class="mb-0">
                {{ taskCount['other']['open'] }}
              </h3>
              Open
            </div>
            <div class="text-center">
              <h3 class="mb-0">
                {{ taskCount['other']['remaining'] }}
              </h3>
              In Progress
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card card-shadow mx-lg-2 mb-lg-2">
      <div class="card-body">
        <h3 class="card-title">Recent Clients</h3>
        <em>Coming Soon...</em>
      </div>
    </div>
    <div class="card card-shadow ms-lg-2 mb-lg-2">
      <div class="card-body">
        <h3 class="card-title">Quick Links</h3>
        <ul class="no-style">
          <li *hasMinRole="'CSR1'">
            <h6>
              <a routerLink="/clients">
                <strong>Full Client List</strong>
              </a>
            </h6>
          </li>
          <li *ngIf="auth.isInAnyRole(['Onboarding', 'Sales'])">
            <h6>
              <a routerLink="/onboarding/home">
                <strong>Client Connection</strong>
              </a>
            </h6>
          </li>
          <li *ngIf="auth.isInAnyRole(['Corporate_Reports'])">
            <h6>
              <a routerLink="/reports">
                <strong>Corporate Reports</strong>
              </a>
            </h6>
          </li>
          <!-- Task 9208/9:
            the goal is to have a max of 1 clic data binder link display in the bottom right corner.
            if the user is a supervisor, they will see the supervisor link only.
            else if the user is a CSR and not a supervisor, display the CSR link
            else display nothing
           -->
          <li *ngIf="auth.isInAnyRole(['CSR', 'CSR1']) && !auth.isInAnyRole(['Supervisor'])">
            <h6>
              <a routerLink="/reports/payroll-wip-csr">
                <strong>Payroll WIP Tracking (CSR)</strong>
              </a>
            </h6>
          </li>
          <li *ngIf="auth.isInAnyRole(['Supervisor'])">
            <h6>
              <a routerLink="/reports/payroll-wip-supervisor">
                <strong>Payroll WIP Tracking (Supervisor)</strong>
              </a>
            </h6>
          </li>
          <li>
            <h6>
              <strong>
                <a
                  href="https://one.zoho.com/zohoone/connectpay/home/cxapp/support/agent/connectpay/payroll-operations/knowledge-base/page#Solutions"
                  target="_blank">
                  FAQ&nbsp;<i class="fas fa-anchor"></i>
                </a>
              </strong>
            </h6>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
<ng-template #taskModal let-modal>
  <form [formGroup]="taskForm" autocomplete="off" class="padded-form">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Task</h4>
      <button
        cpGTagEvent
        [params]="{ event_label: 'csr_home_task_modal_dismiss' }"
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-12">
          <label>Task Type</label>
          <select class="form-control" formControlName="Type" (ngModelChange)="onTaskTypeChange()">
            <option *ngFor="let type of taskTypes" value="{{ type.Name }}">{{ type.Name }}</option>
          </select>
          <div *ngIf="t.Type.errors?.required" class="input-error">*required</div>
        </div>
      </div>
      <fieldset [disabled]="disableTaskDueDate">
        <div class="row">
          <div class="col-sm-6">
            <label>Due Date</label>
            <div class="input-group">
              <input
                formControlName="DueDate"
                class="form-control datepicker"
                ngbDatepicker
                #addTaskdatepicker="ngbDatepicker"
                [firstDayOfWeek]="7"
                [placement]="['bottom-end', 'top-end']"
                (ngModelChange)="checkDueDateTime()"
                [ngClass]="{ 'ng-invalid': invalidTaskDueDate }" />
              <div *ngIf="t.DueDate.errors?.required" class="input-error input-group-error">
                *required
              </div>
              <div
                *ngIf="!t.DueDate.valid && !t.DueDate.errors?.required"
                class="input-error input-group-error">
                *invalid date
              </div>
              <div
                *ngIf="t.DueDate.valid && invalidTaskDueDate && !disableTaskDueDate"
                class="input-error input-group-error show-untouched">
                *due date must be after {{ formattedTaskMinDate }}
              </div>
              <img
                *ngIf="addTaskdatepicker"
                src="assets/icons/calendar.svg"
                (click)="addTaskdatepicker.toggle()"
                class="icon-append" />
            </div>
          </div>
          <div class="col-sm-6">
            <label>Time</label>
            <ngb-timepicker
              [(ngModel)]="dueByTime"
              [ngModelOptions]="{ standalone: true }"
              [meridian]="true"
              [spinners]="false"
              (ngModelChange)="checkDueDateTime()"
              [ngClass]="{ 'ng-invalid': invalidTaskDueDate }"></ngb-timepicker>
          </div>
        </div>
      </fieldset>
      <div class="row" *ngIf="currentTask && stringContains(t.Type.value, 'Payroll')">
        <div class="col-lg-6">
          <label>Pay Date</label>
          <input *ngIf="!currentTask.PayDate" class="form-control" [value]="" [disabled]="true" />
          <ng-container *ngIf="currentTask.PayDate">
            <input
              class="form-control"
              [value]="currentTask.PayDate | date: 'MM/dd/yyyy'"
              [disabled]="true" />
            <div class="input-validator">
              {{ getDayOfWeek(currentTask.PayDate) }}
            </div>
          </ng-container>
        </div>
        <div class="col-lg-6">
          <label>Received by</label>
          <input
            class="form-control"
            [value]="currentTask.PayrollInputMethod || ''"
            [disabled]="true" />
        </div>
        <div class="col-lg-4">
          <label>Frequency</label>
          <input class="form-control" [value]="currentTask.PayFrequency || ''" [disabled]="true" />
        </div>
        <div class="col-lg-4">
          <label>Payroll Type</label>
          <input class="form-control" [value]="currentTask.PayrollType || ''" [disabled]="true" />
        </div>
        <div class="col-lg-4">
          <label>Payroll Status</label>
          <input class="form-control" [value]="currentTask.PayrollStatus || ''" [disabled]="true" />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <label>Client</label>
          <client-autocomplete-input
            [data]="clients"
            [initialQuery]="initialClientQuery"
            [minSearchLength]="1"
            [searchObs]="clientSearchObs"
            [isDisabled]="isCurrentTaskRestrictedEdit()"
            (setData)="setClientData($event)"
            (setQuery)="setClientQuery($event)"
            (valueSelected)="clientValueSelected($event)">
          </client-autocomplete-input>
          <div *ngIf="invalidSelClient" class="input-error">*invalid Client</div>
        </div>
        <div class="col-lg-12" *hasMinRole="'CSR1'">
          <label>CSR</label>
          <select
            class="form-control"
            formControlName="AssigneeAgileId"
            (change)="csrChanged($event)">
            <option></option>
            <option *ngFor="let usr of teamMembers" value="{{ usr.userName.toLowerCase() }}">
              {{ usr.firstName }} {{ usr.lastName }}
            </option>
          </select>
          <div *ngIf="t.AssigneeAgileId.errors?.required" class="input-error">*required</div>
        </div>
      </div>
      <!-- client contact -->
      <div class="row" *ngIf="t.ContactName || t.ContactPhone || t.ContactEmail">
        <div class="col-lg-4">
          <label>Contact Name</label>
          <input class="form-control" [disabled]="true" value="{{ t.ContactName }}" />
        </div>
        <div class="col-lg-4">
          <label>Phone</label>
          <input class="form-control" [disabled]="true" value="{{ t.ContactPhone }}" />
          <div
            class="input-validator"
            *ngIf="t.ContactPhone && t.ContactPhone.value != '(___) ___-____'">
            <a href="{{ 'tel:' + t.ContactPhone }}" class="green-link">
              <strong>call</strong>
            </a>
          </div>
        </div>
        <div class="col-lg-4">
          <label>Email</label>
          <div class="input-validator" *ngIf="t.ContactEmail">
            <a href="{{ 'mailto:' + t.ContactEmail }}" class="green-link">
              <strong>send email</strong>
            </a>
          </div>
          <input class="form-control" [disabled]="true" value="{{ t.ContactEmail }}" />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <label>Priority</label>
          <select class="form-control" formControlName="Priority">
            <option value="1">Low</option>
            <option value="2">Medium</option>
            <option value="3">High</option>
            <option value="4">Urgent</option>
          </select>
          <div *ngIf="t.Priority.errors?.required" class="input-error">*required</div>
        </div>
        <div class="col-lg-6">
          <label>Status</label>
          <select class="form-control" formControlName="Status" (change)="taskStatusChanged()">
            <option *ngFor="let status of taskStatuses | enumToKeyValue" value="{{ status.value }}">
              {{ status.key | camelToTitle }}
            </option>
          </select>
          <div *ngIf="t.Status.errors?.required" class="input-error">*required</div>
        </div>
        <div class="col-lg-12 mb-3">
          <label>Description</label>
          <textarea class="form-control" formControlName="Description" rows="3"></textarea>
          <!-- <ckeditor [editor]="textEditor" formControlName="Description"
                    [config]="{ toolbar: [  'heading', '|', 'bold', 'italic', 'numberedList', 'bulletedList', '|', 'undo', 'redo'] }">
          </ckeditor> -->
          <div *ngIf="t.Description.errors?.required" class="input-error input-error--ckeditor">
            *required
          </div>
          <div *ngIf="t.Description.value && !t.Description.value.trim()" class="input-error">
            *Description cannot be blank
          </div>
        </div>
        <div class="col-lg-12 nav-item-pb-0">
          <ul ngbNav #nav="ngbNav" class="nav-tabs" (navChange)="onNotesNavChange($event)">
            <li ngbNavItem [ngbNavItem]="'task-notes'">
              <a ngbNavLink class="tab-title">Notes on this Task</a>
              <ng-template ngbNavContent>
                <textarea class="mt-3 form-control" formControlName="TaskNote" rows="3"></textarea>
                <!-- <ckeditor class="mt-3" [editor]="textEditor" formControlName="TaskNote"
                          [config]="{ toolbar: [  'heading', '|', 'bold', 'italic', 'numberedList', 'bulletedList', '|', 'undo', 'redo'] }">
                </ckeditor> -->
              </ng-template>
            </li>
            <li ngbNavItem [ngbNavItem]="'client-notes'">
              <a ngbNavLink class="tab-title">Permanent Client Notes</a>
              <ng-template ngbNavContent>
                <div style="position: absolute; right: 15px; top: 30px">
                  <small>
                    <a (click)="getActiveClientNote()" class="cp-green">
                      Refresh Note&nbsp;<i class="fas fa-sync-alt"></i>
                    </a>
                  </small>
                </div>
                <fieldset [attr.disabled]="!selClientCode ? 'disabled' : null">
                  <textarea
                    formControlName="ClientNote"
                    class="form-control mb-0 mt-3 pre"
                    rows="3"
                    (ngModelChange)="saveClientNote()"></textarea>
                </fieldset>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav"></div>
          <div>
            <small
              [hidden]="
                !taskNoteLastUpdateBy && !taskNoteLastUpdateDate && !taskNoteLastUpdateTime
              ">
              <strong>Last Updated&nbsp;</strong>
              <span *ngIf="taskNoteLastUpdateBy">
                <strong>by</strong> {{ taskNoteLastUpdateBy }}
              </span>
              <span *ngIf="taskNoteLastUpdateDate">
                <strong>on</strong> {{ taskNoteLastUpdateDate }}
              </span>
              <span *ngIf="taskNoteLastUpdateTime">
                <strong>at</strong> {{ taskNoteLastUpdateTime }}
              </span>
            </small>
            &nbsp;
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        cpGTagEvent
        [params]="{ event_label: 'csr_home_task_modal_cancel' }"
        type="button"
        class="btn btn-secondary"
        (click)="modal.dismiss()">
        Cancel
      </button>
      <button
        cpGTagEvent
        [params]="{ event_label: 'csr_home_task_modal_save' }"
        type="button"
        class="btn btn-primary"
        (click)="modal.close()"
        [attr.disabled]="
          invalidSelClient || !taskForm.valid || invalidTaskDueDate ? 'disabled' : null
        ">
        Save
      </button>
    </div>
  </form>
</ng-template>
<ng-template #batchTaskModal let-modal>
  <form [formGroup]="taskForm" autocomplete="off" class="padded-form">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Edit Tasks</h4>
      <button
        cpGTagEvent
        [params]="{ event_label: 'csr_home_batch_edit_dismiss' }"
        type="button"
        class="close"
        aria-label="Close"
        (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <fieldset [disabled]="disableTaskDueDate">
        <div class="row">
          <div class="col-sm-12">
            <label>Due Date</label>
            <div class="input-group">
              <input
                formControlName="DueDate"
                class="form-control datepicker"
                ngbDatepicker
                #addTaskdatepicker="ngbDatepicker"
                [firstDayOfWeek]="7"
                (ngModelChange)="checkDueDateTime()"
                [placement]="['bottom-end', 'top-end']"
                [ngClass]="{ 'ng-invalid': invalidTaskDueDate && t.DueDate.value }" />
              <div *ngIf="!t.DueDate.valid" class="input-error input-group-error">
                *invalid date
              </div>
              <div
                *ngIf="t.DueDate.valid && invalidTaskDueDate && !disableTaskDueDate"
                class="input-error input-group-error">
                *due date must be after {{ formattedTaskMinDate }}
              </div>
              <img
                src="assets/icons/calendar.svg"
                (click)="addTaskdatepicker.toggle()"
                class="icon-append" />
            </div>
          </div>
          <div class="col-sm-12">
            <label>Time</label>
            <ngb-timepicker
              [(ngModel)]="dueByTime"
              [ngModelOptions]="{ standalone: true }"
              [meridian]="true"
              [spinners]="false"
              (ngModelChange)="checkDueDateTime()"
              [ngClass]="{ 'ng-invalid': invalidTaskDueDate }"></ngb-timepicker>
          </div>
        </div>
      </fieldset>
      <div class="row">
        <div class="col-lg-12" *hasMinRole="'CSR1'">
          <label>CSR</label>
          <select
            class="form-control"
            formControlName="AssigneeAgileId"
            (change)="csrChanged($event)">
            <option></option>
            <option *ngFor="let usr of teamMembers" value="{{ usr.userName }}">
              {{ usr.firstName }} {{ usr.lastName }}
            </option>
          </select>
        </div>
        <div class="col-lg-12">
          <label>Status</label>
          <select class="form-control" formControlName="Status" (change)="taskStatusChanged()">
            <option *ngFor="let status of taskStatuses | enumToKeyValue" value="{{ status.value }}">
              {{ status.key | camelToTitle }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        cpGTagEvent
        [params]="{ event_label: 'csr_home_batch_edit_cancel' }"
        type="button"
        class="btn btn-secondary"
        (click)="modal.dismiss()">
        Cancel
      </button>
      <button
        cpGTagEvent
        [params]="{ event_label: 'csr_home_batch_edit_save' }"
        type="button"
        class="btn btn-primary"
        (click)="modal.close()"
        [attr.disabled]="
          !t.Status.valid && !invalidTaskDueDate && !t.AssigneeAgileId.valid ? 'disabled' : null
        ">
        Save
      </button>
    </div>
  </form>
</ng-template>
<ng-template #nonCSRTasks>
  <div class="card card-shadow" *ngIf="auth.isInAnyRole(['Banking'])">
    <div class="card-body">
      <h3 class="card-title">Task List</h3>
      <h5>Coming Soon</h5>
    </div>
  </div>
</ng-template>
